//import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import SwitchTenant from "./";
import { ITenantService } from "@/services/tenant-service/IResourceService.ts";
import { TenantService } from "@/services/tenant-service/TenantService.ts";
import { TenantInfo } from "@/services/tenant-service/entities/TenantEntity.ts";

const mapDispatchToProps = () => {
  const tenantService: ITenantService = new TenantService();
  return {
    onFetchTenantList: async (): Promise<TenantInfo[]> => {
      const response = await tenantService.getTenantList("");
      if(!response.error) {
        return response.data;
      } else {
        return []
      }
    }
  }
}

export default connect(null, mapDispatchToProps)(SwitchTenant);